import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './showproduct.css';
import ProductReview from './ProductReview';
import FooterButton from './FooterButton';
import Sidebar from './Sidebar';
import { FaBars } from 'react-icons/fa';
import { ProductCategory, getSpecifications } from './ProductCategory';

const ShowProduct = ({ onAddToCart }) => {
  const navigate = useNavigate();

  // State
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [visibleCount, setVisibleCount] = useState(8);
  const [darkMode, setDarkMode] = useState(false);

  const categoryIcons = {
    All: 'https://as2.ftcdn.net/v2/jpg/04/97/08/75/1000_F_497087583_WNfnSVmHSwoNp1iprUUt5CLUuNRIhnnC.jpg',
    Mobiles: 'https://www.pngarts.com/files/3/Smartphone-Mobile-PNG-Image-Background.png',
    Tools: 'https://www.pngall.com/wp-content/uploads/10/Tools-PNG-Photos.png',
    Plumbing: 'https://i.pinimg.com/originals/ae/65/fb/ae65fbf16b24ed45bb172e932dc79807.png',
    Painting: 'https://png.pngtree.com/png-vector/20231116/ourmid/pngtree-isolated-white-background-of-an-aged-png-image_10552531.png',
    Cleaning: 'https://static.vecteezy.com/system/resources/previews/041/642/641/original/ai-generated-cleaning-product-isolated-on-transparent-background-png.png',
    'Mens Clothes': 'https://cdn-icons-png.flaticon.com/512/892/892458.png',
    'Women Clothes': 'https://cdn-icons-png.flaticon.com/512/892/892451.png',
    Unisex: 'https://img.huffingtonpost.com/asset/6494679e2000001b00c8b6b6.png?ops=scalefit_960_noupscale',
    Footwear: 'https://pluspng.com/img-png/shoes-png--1200.png',
    Cosmetics: 'https://cdn-icons-png.flaticon.com/512/2920/2920242.png',
  };

  // Filter logic
  const filteredProducts = ProductCategory.filter(product => {
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.description.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  // Load more products
  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 8);
  };

  // Sidebar toggle
  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  return (
    <div className={`product-list-container ${darkMode ? 'dark-mode' : ''}`}>

      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

      <h1 className="text-danger text-center">⚠️ Don't Pay — This Site is for Testing Only</h1>

      {/* Header */}
      <h2 className="text-center text-dark">
        <button className="menu-btn" onClick={toggleSidebar}>
          <FaBars size={24} />
        </button>
        Products & Tools
        <button onClick={() => navigate('/foodgallery')} className="menu-btn">
          <FaBars size={24} /> Food
        </button>
      </h2>

      {/* Category Tabs */}
      <div className="category-tabs">
        {Object.keys(categoryIcons).map(cat => (
          <button
            key={cat}
            className={`category-tab ${selectedCategory === cat ? 'active' : ''}`}
            onClick={() => setSelectedCategory(cat)}
          >
            <img src={categoryIcons[cat]} alt={cat} className="category-icon" />
            <span>{cat}</span>
          </button>
        ))}
      </div>

      {/* Controls */}
      <div className="controls">
        <input
          type="text"
          placeholder="Search products..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="search-input"
        />

        <button onClick={() => setDarkMode(!darkMode)} className="dark-toggle">
          {darkMode ? 'Light' : 'Dark'} Mode
        </button>
      </div>

      {/* Product Grid */}
      <div className="product-grid">
        {filteredProducts.slice(0, visibleCount).map(product => (
          <div className="product-card" key={product.id}>
            <img
              src={product.image}
              alt={product.name}
              className="product-image"
              onClick={() => {
                setSelectedProduct(product);
                setShowModal(true);
              }}
            />
            <h4 className="product-name">{product.name}</h4>
            <p className="product-description">{product.description}</p>
            <p className="product-price">₹{product.price}</p>
            <div className="product-buttons">
              <button className="btn add-cart" onClick={() => onAddToCart(product)}>Add to Cart</button>
              <button
                className="btn buy-now"
                onClick={() => navigate(`/buy-now/${product.id}`, { state: { product } })}
              >
                Buy Now
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Load More Button */}
      {visibleCount < filteredProducts.length && (
        <div className="load-more-container">
          <button className="load-more-btn" onClick={handleLoadMore}>Load More</button>
        </div>
      )}

      {/* Modal */}
      {showModal && selectedProduct && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={() => setShowModal(false)}>×</button>
            <img src={selectedProduct.image} alt={selectedProduct.name} className="modal-image" />
            <h2>{selectedProduct.name}</h2>
            <p><strong>Price:</strong> ₹{selectedProduct.price}</p>
            <p><strong>Category:</strong> {selectedProduct.category}</p>
            <p>{selectedProduct.description}</p>
            <h3>Specifications:</h3>
            <ul>
              {getSpecifications(selectedProduct.category).map((spec, index) => (
                <li key={index}><strong>{spec.label}:</strong> {spec.value}</li>
              ))}
            </ul>
          </div>
        </div>
      )}

      <FooterButton />
      <ProductReview />
    </div>
  );
};

export default ShowProduct;
